import React, { useState } from "react";
import "./autosuggest.css";
import { connect } from "react-redux";
// import Autocomplete from "react-autocomplete"; // Package removed
// Simple autocomplete replacement
const Autocomplete = ({
  items,
  value,
  onChange,
  onSelect,
  renderItem,
  getItemValue,
  wrapperStyle,
  onMenuVisibilityChange,
  open,
  inputProps,
  ...otherProps
}) => {
  const [showItems, setShowItems] = useState(false);
  const filteredItems = items?.filter((item) =>
    getItemValue(item).toLowerCase().includes(value?.toLowerCase())
  );

  // Extract only valid HTML input props
  const { id, type, name, placeholder, className } = inputProps || {};

  return (
    <div style={{ position: "relative", ...(wrapperStyle || {}) }}>
      <input
        value={value}
        onChange={(e) => {
          onChange(e);
          setShowItems(true);
        }}
        onFocus={() => setShowItems(true)}
        onBlur={() => setTimeout(() => setShowItems(false), 200)}
        id={id}
        type={type}
        name={name}
        placeholder={placeholder}
        className={className}
      />

      {showItems && filteredItems?.length > 0 && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            background: "white",
            border: "1px solid #ccc",
            maxHeight: "200px",
            overflow: "auto",
            zIndex: 1000,
          }}
        >
          {filteredItems.map((item, i) => (
            <div
              key={i}
              onClick={() => {
                onSelect(getItemValue(item));
                setShowItems(false);
              }}
              style={{ padding: "8px", cursor: "pointer" }}
            >
              {renderItem ? renderItem(item, false) : getItemValue(item)}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
import RedocParameterLabel from "../redocParametersRegion/redocParamersLabel/redocParameterLabel";

const RedocParameterInput = (props) => {
  const { id, param, error, value, suggestions, valueHistory, onChange } =
    props;
  const [visible, setVisible] = useState(false);

  const getSuggestions = () => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;

    // Handle valueHistory as either Immutable or plain object
    let historyValues = [];
    if (valueHistory) {
      if (
        typeof valueHistory.has === "function" &&
        typeof valueHistory.get === "function"
      ) {
        // Immutable.js Map
        if (valueHistory.has(param.name)) {
          const paramHistory = valueHistory.get(param.name);
          historyValues =
            typeof paramHistory.valueSeq === "function"
              ? paramHistory.valueSeq().toArray()
              : Object.values(paramHistory || {});
        }
      } else if (typeof valueHistory === "object") {
        // Plain object
        const paramHistory = valueHistory[param.name];
        historyValues = paramHistory ? Object.values(paramHistory) : [];
      }
    }

    const result = suggestions ? suggestions : historyValues;

    return inputLength === 0
      ? result
      : result.filter(
          (item) => item.toLowerCase().slice(0, inputLength) === inputValue
        );
  };

  const handleChange = (event) => {
    if (onChange) {
      onChange(event, param);
    }
  };

  const handleSelect = (value) => {
    if (onChange) {
      onChange(
        {
          target: {
            value,
          },
        },
        param
      );
    }
  };

  const handleMenuVisibilityChange = (isOpen) =>
    setVisible(isOpen && inputSuggestions && inputSuggestions.length > 0);
  const inputSuggestions = getSuggestions();
  return (
    <tr>
      <RedocParameterLabel param={param} id={id} />
      <td>
        <Autocomplete
          wrapperStyle={{
            display: "block",
          }}
          getItemValue={(item) => item}
          items={inputSuggestions}
          renderItem={(item, isHighlighted) => (
            <div
              className="react-autosuggest__suggestion"
              style={{ background: isHighlighted ? "cornsilk" : "white" }}
            >
              {item}
            </div>
          )}
          onMenuVisibilityChange={handleMenuVisibilityChange}
          open={visible}
          value={value}
          onChange={handleChange}
          onSelect={handleSelect}
          inputProps={{
            id,
            type: "text",
            className: error ? "has-error" : null,
            name: param.name,
            placeholder: param.name,
            required: param.required,
          }}
        />
      </td>
    </tr>
  );
};

const mapStateToProps = (state) => {
  // Helper to safely access properties whether they're plain objects or Immutable
  const getValue = (obj, key) => {
    if (!obj) return undefined;
    // If obj has get method (Immutable), use it
    if (typeof obj.get === "function") {
      return obj.get(key);
    }
    // Otherwise, access plain object property
    return obj[key];
  };

  return {
    valueHistory: getValue(state.tryout, "valueHistory"),
  };
};

export default connect(mapStateToProps, null)(RedocParameterInput);
